<template>
  <sidebar-menu
    v-click-outside="closeMenu"
    :hideToggle="true"
    :collapsed="collapsed"
    :disableHover="true"
    :menu="menu"
    @item-click="onItemClick"
  >
    <div class="header" slot="header">
      <img src="../assets/icons/tabIcon.png" alt="Command line icon" />
    </div>
    <div class="footer" slot="footer" v-if="!collapsed">
      <span style="margin-bottom:3%">Created by</span>
      <a
        :href="externalLinks.github"
        :arial-label="externalLinks.github"
        target="_blank"
      >
        <img
          class="avatar"
          src="../assets/icons/avatar.png"
          alt="Geek smiley icon"
        />
      </a>
    </div>
  </sidebar-menu>
</template>

<script>
import ClickOutside from 'vue-click-outside';

export default {
  name: 'sideMenu',
  props: [
    'collapsed',
    'closeMenu',
    'leave',
    'handleCommand',
    'externalLinks',
    'disableClick'
  ],
  directives: {
    ClickOutside
  },
  methods: {
    onItemClick(event, item) {
      if (this.leave || this.disableClick) return;

      this.$props.handleCommand(item.cmd);
    }
  },
  data() {
    return {
      menu: [
        {
          title: 'Home',
          cmd: 'exit',
          icon: 'fa fa-home'
        },
        {
          title: 'Who Am I',
          cmd: 'whoami',
          icon: 'fas fa-user'
        },
        {
          title: 'Skills',
          cmd: 'skills',
          icon: 'fa fa-cogs'
        },
        {
          title: 'Experience',
          cmd: 'experience',
          icon: 'fa fa-history'
        },
        {
          title: 'Download CV',
          cmd: 'cv',
          icon: 'fa fa-file-pdf'
        },
        {
          title: 'Github',
          cmd: 'github',
          icon: 'fab fa-github'
        },
        {
          title: 'NPM',
          cmd: 'npm',
          icon: 'fab fa-npm'
        },
        {
          title: 'LinkedIn',
          cmd: 'linkedin',
          icon: 'fab fa-linkedin'
        },
        {
          title: 'Blog',
          cmd: 'blog',
          icon: 'fab fa-blogger'
        },
        {
          title: 'Twitter',
          cmd: 'twitter',
          icon: 'fab fa-twitter'
        }
      ]
    };
  }
};
</script>

<style>
.footer {
  text-align: center;
  font-size: 20px;
  font-style: italic;
  padding-bottom: 2vh;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

a {
  color: purple;
}

.vsm--mobile-item {
  display: none;
}

.v-sidebar-menu {
  background-color: #009b64ba !important;
}

.header {
  text-align: center;
}

.vsm--header {
  display: none;
}

.v-sidebar-menu.vsm_collapsed .vsm--mobile-bg {
  background-color: #2a2a2e !important;
  border-radius: 0 15px 15px 0;
  width: 80%;
  display: none;
}

.vsm--list {
  padding-top: 20px;
}

.vsm--icon {
  background-color: transparent !important;
  font-size: 25px;
}

.vsm--title {
  font-size: 30px;
}

.avatar {
  transition: transform 0.25s ease-in-out;
  -webkit-user-select: none;
  -webkit-user-drag: none;
  margin-left: 5px;
  width: 30px;
  height: 30px;
}

.avatar:hover {
  transform: rotate(35deg) scale(1.15);
}
</style>
